module.exports = __webpack_public_path__ + "img/7_51.6dcbbb2d.png";